import { render, staticRenderFns } from "./SetupAccount.vue?vue&type=template&id=470a7028&scoped=true&"
import script from "./SetupAccount.vue?vue&type=script&lang=js&"
export * from "./SetupAccount.vue?vue&type=script&lang=js&"
import style0 from "./SetupAccount.vue?vue&type=style&index=0&id=470a7028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470a7028",
  null
  
)

export default component.exports